import { createAsyncThunk } from "@reduxjs/toolkit";
import publishingCloudAPIs from "services/api/publisher/publishingCloudAPIs";

export const getCloudPreSignedURL = createAsyncThunk("publishingCloud/getCloudPreSignedURL", async (payload) => {
  try {
    const response = await publishingCloudAPIs.getCloudPreSignedURL(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDownloadVideo = createAsyncThunk("publishingCloud/getDownloadVideo", async (payload) => {
  try {
    const response = await publishingCloudAPIs.getDownloadVideo(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const publicDownloadVideo = createAsyncThunk("publishingCloud/publicDownloadVideo", async (payload) => {
  try {
    const response = await publishingCloudAPIs.publicDownloadVideo(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDownloadStatus = createAsyncThunk("publishingCloud/getDownloadStatus", async (payload) => {
  try {
    const response = await publishingCloudAPIs.getDownloadStatus(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const getDownloadStreamLimits = createAsyncThunk("stream/getDownloadStreamLimits", async (payload) => {
  try {
    const response = await publishingCloudAPIs.getDownloadStreamLimits(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const updateDownloadHistoryStream = createAsyncThunk("stream/updateDownloadHistoryStream", async (payload) => {
  try {
    const response = await publishingCloudAPIs.updateDownloadHistoryStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const getDownloadBulkVideo = createAsyncThunk("publishingCloud/getDownloadBulkVideo", async (payload) => {
  try {
    const response = await publishingCloudAPIs.getDownloadBulkVideo(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
